import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AppService } from '../../../../services/app.service';
import { ActionButton } from '../../../../models/app/action-button';
import { Person } from '../../../../models/data/app-core/person';
import { Venue } from '../../../../models/data/app-core/venue';
import { PersonService } from '../../../../services/persons/person.service';
import { UserSession } from '../../../../interfaces/user-session';
import { PersonSearchResult } from '../../../../models/net/result/person-search-result';
import { PersonSearchRequest } from '../../../../models/net/request/person-search-request';
import { ReadResult } from '../../../../models/net/result/crud/read-result';
import { PersonEnvelope } from '../../../../models/net/envelope/person-envelope';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';

@Component({
    selector: 'app-venue-person-settings',
    templateUrl: './venue-person-settings.component.html',
    styleUrls: ['./venue-person-settings.component.css', '../../../../app.component.css']
})

export class VenuePersonSettingsComponent implements OnInit, OnDestroy {

    public title: string = "Session:";
    public subtitle: string = "You are logged in with user credentials {User.UID} with roles {roles.map((role) => role.UID)}";
    public availableOrganizationalUnits: AvatarPrimitive[] = [];
    public selectedOrganizationalUnitIds: number[] = [];
    public currentPerson: Person | undefined;
    public personEnvelope: PersonEnvelope | null = null;
    public currentVenue: Venue | undefined;

    @HostBinding("class.component-flex-vertical-fill") addClass = true;

    private destroy$ = new Subject<void>();

    public constructor(public appService: AppService, private personService: PersonService) {

        const userSessionString: string | null = this.appService.getUserSession();

        if (userSessionString) {

            const userSession: UserSession = JSON.parse(userSessionString);

            let personSearchRequest: PersonSearchRequest = new PersonSearchRequest();

            personSearchRequest.BasicSearchString.SearchString = userSession.userUID;
            personSearchRequest.BasicSearchString.IsWildPrefix = false;
            personSearchRequest.BasicSearchString.IsWildSuffix = false;

            this.personService.search(personSearchRequest).subscribe((r: PersonSearchResult[]) => {

                if (r) {

                    if (r.length > 0) {

                        let personId: number | undefined;

                        if (r.length > 1) {

                            personId = r.find((p: PersonSearchResult) => p.UserUID === userSession.userUID)?.PersonId;

                        } else {

                            personId = r[0].PersonId;
                        }

                        if (personId) {

                            // go get the person envelope which contains the organizational unit membership details
                            this.personService.read(personId).subscribe((readResult: ReadResult | null) => {

                                if (readResult) {

                                    this.personEnvelope = readResult.ReadEnvelope as PersonEnvelope;
                                    this.currentPerson = (readResult.ReadEnvelope as PersonEnvelope).Document.Item;

                                    // setup the title and subtitle
                                    this.title = "Welcome " + this.currentPerson?.FirstName;
                                    this.subtitle = "You are logged in with user credentials " + userSession.userUID + " as " + this.currentPerson?.FirstName + " " + this.currentPerson?.LastName;
                                }
                            });
                        }
                    }
                }
            });
        }
    }

    public ngOnInit(): void { }

    public ngOnChanges() { }

    public ngAfterViewInit(): void { }

    public ngOnDestroy() {

        this.appService.setActionsDataSource([]);
        this.destroy$.next();
        this.destroy$.complete();
    }
}
